module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_resort_sola-b48b40572ffbe6af750bc25a2dc2d351.webp";